/* jshint esversion: 6 */
import { of } from 'rxjs';
import { filter, map, mergeMap, startWith, withLatestFrom } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    SocialActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchSocialsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => {
        let state = state$.value;
        // Short circuit pulls of the main list --- CRUD operations will work on the state
        // so in theory we only need to pull the main list once
        // TODO: determine if we need an expiration
        if (state.socials.list.length && (action.force === undefined || action.force === false)) {
            return of(SocialActions.receiveSocials(state.socials.list));
        } else {
            return api(action.type, state$, null, null, SocialActions.receiveSocials);
        }

    })
);

/*
 * A show can be answered from the social as it stood before an update and still
 * land after the update's answer, as when the socials page opens a detail on
 * coming back from a reconnect. An update reads the social back after its own
 * write, so once one is answered for the same social the show's answer is marked
 * superseded, and the stores keep the update's.
 */
export const fetchSocialEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => {
        let updated = action$.pipe(
            filter(({type, status, payload}) => type === constants.SOCIAL_UPDATE && status === constants.STATE_SUCCESS &&
                payload && parseInt(payload.id, 10) === parseInt(action.id, 10)),
            map(() => true),
            startWith(false)
        );

        return api(action.type, state$, action.id, null, SocialActions.receiveSocial).pipe(
            withLatestFrom(updated),
            map(([answer, superseded]) => (superseded && answer.status === constants.STATE_SUCCESS) ? {...answer, superseded} : answer)
        );
    })
);

export const updateSocialEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SocialActions.updatedSocial))
);

export const deleteSocialEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.deletedSocial))
);

export const createSocialEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SocialActions.createdSocial))
);

export const createBatchSocialsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_CREATE_BATCH && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SocialActions.createdBatchSocials))
);

export const createBatchPollEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_BATCH_POLL && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SocialActions.createdBatchPoll))
);

export const fetchSocialLogEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_LOG && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.receiveSocialLog))
);

export const checkSocialAuthEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_CHECK_AUTH && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.checkedSocialAuth))
);

export const fetchSocialTypesEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_TYPE_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, SocialActions.receiveSocialTypes))
);

export const fetchSocialTypeDefaultsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_TYPE_DEFAULTS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.receiveSocialTypeDefaults))
);

export const fetchQueueCountEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_QUEUE_COUNT && action.status === constants.STATE_TXRX)),
    // count_api answers with the count alone, so the social it's for comes from the request
    mergeMap(action => api(action.type, state$, action.id, null, (payload) => SocialActions.receiveQueueCount({...payload, id: action.id})))
);

export const fetchYouTubeCategoriesEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_GET_CATEGORIES && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.receiveYouTubeCategories))
);

export const fetchYouTubePlaylistsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_GET_PLAYLISTS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialActions.receiveYouTubePlaylists))
);

export const fetchSocialPostAnalyticsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_GET_POST_ANALYTICS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SocialActions.receiveSocialPostAnalytics))
);
